import { render, staticRenderFns } from "./StudentDisplay.vue?vue&type=template&id=99ef9614"
import script from "./StudentDisplay.vue?vue&type=script&lang=js"
export * from "./StudentDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports